import { Translate, Check, CaretDown } from "@phosphor-icons/react";
import { useLanguage, langLabel } from "@/context/LanguageContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

// Compact language picker for the header (India edition). Lists all regional
// languages; the active one is checked. English acts as the reset.
export default function LanguageSwitcher({ className = "", variant = "desktop" }) {
  const { lang, setLang, langs, enabled } = useLanguage();
  if (!enabled) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={variant === "mobile" ? "language-switcher-mobile" : "language-switcher"}
          className={`inline-flex items-center gap-1.5 rounded-full border border-border/70 bg-white px-3 py-1.5 text-sm font-medium text-foreground/80 transition-colors hover:border-primary/50 hover:text-primary ${className}`}>
          <Translate size={16} weight="duotone" className="text-primary" />
          <span>{langLabel(lang)}</span>
          <CaretDown size={12} className="opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between gap-3">
            <span className="flex flex-col">
              <span>{l.native}</span>
              {l.code !== "en" && <span className="text-[11px] text-muted-foreground">{l.label}</span>}
            </span>
            {lang === l.code && <Check size={15} weight="bold" className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
